<template>
  <b-container id="user-login">
    <mtg-header />
    <b-form @submit.prevent="onSubmit" novalidate :validated="wasValidated">
      <b-container class="container--max-610 mt-3 mt-md-4">
        <b-card>
          <h1 class="h3 mb-6">{{ $t("lang.label_login") }}</h1>
          <b-form-group :label="$t('lang.label_email')" label-for="input-email">
            <b-form-input v-model="user.username" id="input-email" type="email" required :placeholder="$t('lang.label_placeholder_email')"></b-form-input>
            <b-form-invalid-feedback>{{ $t("lang.label_placeholder_email") }}</b-form-invalid-feedback>
            <small class="form-text" id="active_mail_help_block">
              <router-link :to="{ name: 'activate-MailAddress', params: { givenUserEmail: user.username } }">{{ $t("lang.label_MailAddress_not_activated") }} </router-link>
            </small>
          </b-form-group>
          <b-form-group :label="$t('lang.label_password')" label-for="input-password">
            <b-form-input v-model="user.password" id="input-password" type="password" required :placeholder="$t('lang.label_placeholder_password')"></b-form-input>
            <b-form-invalid-feedback>{{ $t("lang.label_placeholder_password") }}</b-form-invalid-feedback>

            <small class="form-text" id="password-help-block">
              <router-link :to="{ name: 'forgot-password', params: { givenUserEmail: user.username } }">{{ $t("lang.label_password_forgot") }} </router-link>
            </small>
          </b-form-group>
          <b-row class="mt-5">
            <b-col sm>
              <p>
                {{ $t("lang.label_login_dontHaveAccount") }}<br />
                <router-link to="/register"> {{ $t("lang.label_register") }}</router-link>
              </p>
            </b-col>
            <b-col sm class="text-right">
              <b-button type="submit" size="lg" variant="primary" :disabled="isLoading">{{ $t("lang.label_signIn") }}</b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </b-form>
  </b-container>
</template>
<script>
import MtgHeader from "../components/layout/MtgHeader";
export default {
  name: "UserLogin",
  data() {
    return {
      user: {
        username: "",
        password: ""
      },
      wasValidated: false
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters["isLoading"];
    }
  },
  methods: {
    onSubmit(evt) {
      if (evt.target.checkValidity() === false) {
        this.wasValidated = true;
        return;
      }

      let email = this.user.username;
      let password = this.user.password;
      this.$store
        .dispatch("auth/login", { email, password })
        .then(() => this.$store.dispatch("certificate/getCertificateStatisticsForUser"))
        .then(() => this.$router.push("/dashboard"))
        .catch(() => {
          this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_login_error"));
        });
    }
  },

  components: {
    MtgHeader
  }
};
</script>
<style scoped></style>
